const React = require("react");
const { usePrintify } = require("../context/PrintifyContext");
const { useResource } = require("../hooks/useResource");
const { PageHeader, LinkButton, ResourceState, StatusBadge, Kpi } = require("../components/ui");
const h = React.createElement;

const SellerPrintifyDashboard = () => {
  const { api, t } = usePrintify();
  const resource = useResource(async () => ({ ...(await api.getPlatform()), ...(await api.getConnection()) }), [api]);
  const platform = resource.data?.platform;
  const connection = resource.data?.connection;
  const connected = connection?.status === "connected";
  return h(React.Fragment, null,
    h(PageHeader, {
      title: t("h_printify_dashboard", "Printify"),
      description: t("h_printify_dashboard_desc", "Manage your Printify shops, products and fulfillment from Elakay."),
    }),
    h(ResourceState, { loading: resource.loading, error: resource.error, empty: !platform, reload: resource.reload, t }, platform ? h(React.Fragment, null,
      h("article", { className: "pyds-card" }, h("div", { className: "pyds-card-body" },
        h("div", { className: "pyds-row pyds-between" },
          h("div", { className: "pyds-row" },
            h("img", { src: platform.logo, width: 46, height: 46, alt: "Printify" }),
            h("div", null, h("h3", null, connection?.accountName || "Printify"), connection?.accountEmail ? h("p", { className: "pyds-muted" }, connection.accountEmail) : null)
          ),
          h(StatusBadge, { status: connection?.status || "not_connected", t })
        ),
        h("p", { className: "pyds-muted" }, connected
          ? t("h_printify_connected_desc", "Your Printify account is connected to Elakay.")
          : t("h_printify_not_connected_desc", "Connect Printify to synchronize products and fulfill paid orders.")),
        h("div", { className: "pyds-row" },
          h(LinkButton, { to: "/dropshipping/printify/connect" }, connected ? t("h_printify_manage_connection", "Manage connection") : t("h_printify_connect", "Connect Printify")),
          connected ? h(LinkButton, { to: "/dropshipping/printify/products", variant: "secondary" }, t("h_printify_products", "Products")) : null,
          connected ? h(LinkButton, { to: "/dropshipping/printify/settings", variant: "secondary" }, t("h_printify_settings", "Settings")) : null
        )
      )),
      h("div", { className: "pyds-kpis" },
        h(Kpi, { value: resource.data?.productCount || 0, label: t("h_printify_product_count", "Products") }),
        h(Kpi, { value: connection?.shops?.length || 0, label: t("h_printify_shop_count", "Shops") }),
        h(Kpi, { value: connection?.shopName || "—", label: t("h_printify_primary_shop", "Primary shop") }),
        h(Kpi, { value: connection?.lastSync ? new Date(connection.lastSync).toLocaleDateString() : "—", label: t("h_printify_last_sync", "Last synchronization") })
      )
    ) : null)
  );
};

module.exports = { SellerPrintifyDashboard };
